export default __webpack_public_path__ + "static/media/mainBiggerScreen.817abfc0.jpg";